import styled from 'styled-components';
import InversionLogo from '@assets/images/colors/logo_inversion.svg';
import InversionColorGreen from '@assets/images/colors/inversion_color_green.svg';
import InversionColorBlack from '@assets/images/colors/inversion_color_black.svg';


export const InversionLogoImg = styled(InversionLogo)`
`;

export const InversionColorGreenImg = styled(InversionColorGreen)`
`;

export const InversionColorBlackImg = styled(InversionColorBlack)`
`;